"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3_utils_1 = require("web3-utils");

var Pair =
/** @class */
function () {
  function Pair(_a) {
    var assetA = _a.assetA,
        assetB = _a.assetB;
    this.assetA = assetA;
    this.assetB = assetB;
    this._exchange = null;
  }

  Pair.prototype.setExchange = function (exchange) {
    this._exchange = exchange;
  };

  Pair.prototype.exchangeAtoB = function (_a) {
    var account = _a.account,
        value = _a.value,
        ether = _a.ether;
    throw new Error('Not implemented');
  };

  Pair.prototype.exchangeBtoA = function (_a) {
    var account = _a.account,
        value = _a.value,
        ether = _a.ether;
    throw new Error('Not implemented');
  };

  Object.defineProperty(Pair.prototype, "exchange", {
    get: function get() {
      if (!this._exchange) {
        throw new Error('Exchange not set');
      }

      return this._exchange;
    },
    set: function set(newExchange) {
      this._exchange = newExchange;
    },
    enumerable: true,
    configurable: true
  });

  Pair.prototype._getValue = function (_a) {
    var value = _a.value,
        ether = _a.ether;

    if (!value && !ether) {
      throw new Error('Must provide value for transfer');
    }

    if (value) {
      return value;
    }

    return web3_utils_1.toWei(ether, 'ether');
  };

  return Pair;
}();

exports.default = Pair;